/**
 * @generated SignedSource<<2a8435567926f24085821fa6ba3ef261>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNoteSubscriptionsSubscription$variables = {
  noteId: string;
};
export type useNoteSubscriptionsSubscription$data = {
  readonly noteUpdated: {
    readonly " $fragmentSpreads": FragmentRefs<"NoteNative_note" | "NoteWeb_note">;
  } | null;
};
export type useNoteSubscriptionsSubscription = {
  response: useNoteSubscriptionsSubscription$data;
  variables: useNoteSubscriptionsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNoteSubscriptionsSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "noteUpdated",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NoteWeb_note"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NoteNative_note"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNoteSubscriptionsSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "noteUpdated",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOrgNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noteSize",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "editingMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WidgetNotePage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": "largeImage",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "minHeight",
                        "value": 1080
                      },
                      {
                        "kind": "Literal",
                        "name": "minWidth",
                        "value": 1080
                      }
                    ],
                    "concreteType": "ImageSize",
                    "kind": "LinkedField",
                    "name": "size",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": "size(minHeight:1080,minWidth:1080)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fontColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "includedInSlideshow",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backgroundColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fontSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fontStyle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageScale",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageTranslateX",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageTranslateY",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remoteImageURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "containImage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e888e26e04587050ef2ed8fdeaf12f8e",
    "id": null,
    "metadata": {},
    "name": "useNoteSubscriptionsSubscription",
    "operationKind": "subscription",
    "text": "subscription useNoteSubscriptionsSubscription(\n  $noteId: ID!\n) {\n  noteUpdated(noteId: $noteId) {\n    ...NoteWeb_note\n    ...NoteNative_note\n    id\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment NoteWeb_note on Note {\n  id\n  title\n  isOrgNote\n  noteSize\n  editingMode\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    includedInSlideshow\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  fontColor\n  image {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "83f97a26dbae0290639c2bfc11117001";

export default node;
